module.exports = __webpack_public_path__ + "static/media/zl_2_16.d27bad05.png";